<template>
  <div
    class="x-input-group x-input-group-neutral x-w-full x-rounded-sm !x-outline-0"
    :class="
      isDesktopOrGreater
        ? 'x-border-neutral-10 x-bg-neutral-10'
        : 'x-border-neutral-50 x-bg-neutral-0'
    "
  >
    <SearchInput
      ref="searchInputRef"
      :autofocus="false"
      :placeholder="$t('searchBox.placeholder')"
      :instant="true"
      class="desktop:!x-pl-8"
    />

    <ClearSearchInput
      v-if="isDesktopOrGreater && x.query.searchBox"
      class="x-input-group-button x-input-group-button-rectangle"
    >
      {{ $t('searchBox.clear') }}
    </ClearSearchInput>

    <SearchButton
      v-if="isDesktopOrGreater || !x.query.searchBox"
      class="x-input-group-button-primary x-bg-lead-50"
    >
      <SearchIcon class="x-icon-md desktop:x-icon-lg" />
    </SearchButton>

    <ClearSearchInput v-else class="x-input-group-button-primary x-bg-lead-50">
      <CrossTinyIcon class="x-icon-lg" />
    </ClearSearchInput>
  </div>
</template>

<script setup lang="ts">
import { CrossTinyIcon, SearchIcon, use$x } from '@empathyco/x-components'
import { ClearSearchInput, SearchButton, SearchInput } from '@empathyco/x-components/search-box'
import { ref } from 'vue'
import { useDevice } from '../composables/use-device.composable'

const { isDesktopOrGreater } = useDevice()
const x = use$x()
const searchInputRef = ref<InstanceType<typeof SearchInput>>(null as any)
</script>
